import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
	namespaced: true,
	state: {
		lstLoe: [],
		loe: null,
		selectedLoe: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		lstLof: [],
	},
	getters: {
		loemodel(state){
			const loe = { ...state.loe }; 

			const lstLofCopy = state.lstLof ? [...state.lstLof] : [];
			loe.lstLof = lstLofCopy;
			
			for (const lof of loe.lstLof) {
				lof.loflista   = loe.loelista
				lof.lofcliente = loe.loecliente
				lof.lofenderid = loe.loeenderid
				lof.lofrecibo  = loe.loerecibo
				lof.lofbloccom = loe.loebloccom
				
			}

			return loe
		}
	},
	mutations: {
		set(state, loe){
			state.loe = loe
			if (loe){
				state.update = true
				state.lstLof = loe.lstLof
			}
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.loe = null
			state.lstLof = []
		},
		setParamsDataTable(state, payload){
			state.lstLoe = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async find(store, {loelista, loecliente, loeenderid}){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/Price/SpecialPriceByRental/Find/${loelista}/${loecliente}/${loeenderid}`)
			.then(response => {
				let loe = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", loe)
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},

		save(store){
			if (store.state.update){
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
				
		async update(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indetermlofte: true }, {root: true})

			await this._vm.$axios.put(
				`/Price/SpecialPriceByRental/Update`,
				store.getters.loemodel
			)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/precos-especiais-locacao")
				store.state.loe = null
				store.state.lstLof = []
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
				titleText: "Erro",
				titleColor: "red",
				text: error.message
				}, { root: true })
				return false
			})

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},

		async insert(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indetermlofte: true }, {root: true})

			await this._vm.$axios.post(
				`/Price/SpecialPriceByRental/Insert`,
				store.getters.loemodel
			)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/precos-especiais-locacao")
				store.state.loe = null
				store.state.lstLof = []
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
				titleText: "Erro",
				titleColor: "red",
				text: error.message
				}, { root: true })
				return false
			})

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},

		async delete(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indetermlofte: true }, {root: true})
			await this._vm.$axios.delete(`/Price/SpecialPriceByRental/Delete/${store.state.loe.loelista}/${store.state.loe.loecliente}/${store.state.loe.loeenderid}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/precos-especiais-locacao")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async search(store, { limit = 20, page = 1}){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/Price/SpecialPriceByRental/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstLoe = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
	}
}